import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const TreeMap = ({
  onTreeMapClick,
  question,
  series,
  grandTotal,
  selectedIndex,
}) => {
  const [state, setState] = useState();

  useEffect(() => {
    onTreeMapClick(state);
  }, [state]);

  const [selectedValue, setSelectedValue] = useState(null);

  if (
    document.getElementsByClassName("apexcharts-treemap-rect")[1] &&
    selectedValue === null &&
    selectedIndex === 1
  ) {
    var element = document.getElementsByClassName("apexcharts-treemap-rect")[1];
    element.classList.add("first-element");
  }

  const options = {
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        colors: ["#000"],
      },
      formatter: function (text, op) {
        let returnValue = [
          text,
          op.value,
          ((op.value / grandTotal) * 100).toFixed(1) + "%",
        ];
        if (op.value / grandTotal < 0.2) {
          returnValue = [
            text.length > 17 ? text.slice(0, 15) + "..." : text,
            op.value,
            ((op.value / grandTotal) * 100).toFixed(1) + "%",
          ];
        }
        return returnValue;
      },
      offsetY: -6,
    },
    tooltip: {
      enabled: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return `<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex"><span class="apexcharts-tooltip-marker" style="background-color: rgba(127, 205, 127, 0.85);"></span><div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;"><div class="apexcharts-tooltip-y-group"><span class="apexcharts-tooltip-text-y-label">${
          w.globals.categoryLabels[dataPointIndex]
        }: </span><span class="apexcharts-tooltip-text-y-value">${
          series[seriesIndex][dataPointIndex]
        } (${((series[seriesIndex][dataPointIndex] / grandTotal) * 100).toFixed(
          1
        )}%)</span></div><div class="apexcharts-tooltip-goals-group"><span class="apexcharts-tooltip-text-goals-label"></span><span class="apexcharts-tooltip-text-goals-value"></span></div><div class="apexcharts-tooltip-z-group"><span class="apexcharts-tooltip-text-z-label"></span><span class="apexcharts-tooltip-text-z-value"></span></div></div></div>`;
      },
    },
    plotOptions: {
      treemap: {
        colorScale: {
          ranges: [
            {
              from: 0,
              to: 0,
              color: "#CD363A",
            },
            {
              from: 0.001,
              to: 100000,
              color: "#71daff",
            },
          ],
        },
      },
    },
    chart: {
      toolbar: {
        show: false,
      },
      events: {
        click: function (event, chartContext, config) {
          setState(series[0].data[config.dataPointIndex].x);
          setSelectedValue(config.dataPointIndex);
          var element = document.getElementsByClassName(
            "apexcharts-treemap-rect"
          );
          for (let i = 0; i < series[0].data.length; i++) {
            element[i].classList.remove("first-element");
          }

          element[config.dataPointIndex].classList.add("first-element");
        },
      },
    },
    states: {
      active: {
        filter: { type: "none", value: 1 },
      },
    },
    colors: ["#33b2df"],
  };

  return (
    <>
      <Chart
        options={options}
        series={series}
        type="treemap"
        height="300"
        className="custom-treemap"
      />
    </>
  );
};

export default TreeMap;
